import { ReactNode } from 'react';
import { createContext } from '@chakra-ui/react-utils';
import { useObjectMemo } from '../../utils/utils';
import Box, { BoxProps } from '../Box/Box';
import IconButton from '../IconButton/IconButton';

const [HeaderContext, useHeaderContext] = createContext<{
  onPrevious: () => void;
  onNext: () => void;
  controls: 'left' | 'right' | 'both';
}>();
export const DatePickerHeaderContent = (props: BoxProps) => (
  <Box alignSelf="center" display="flex" gap="8" justifyContent="center" {...props} />
);
export const DatePickerHeaderPrevious = ({ label }: { label: string }) => {
  const { controls, onPrevious } = useHeaderContext();
  return (
    <IconButton
      alignSelf="start"
      aria-label={label}
      as="button"
      color="purple.10"
      iconName="ChevronLeft"
      isTooltipDisabled
      onClick={onPrevious}
      size="sm"
      type="button"
      variant="tertiary"
      visibility={controls === 'right' ? 'hidden' : undefined}
    />
  );
};
export const DatePickerHeaderNext = ({ label }: { label: string }) => {
  const { controls, onNext } = useHeaderContext();
  return (
    <IconButton
      alignSelf="end"
      aria-label={label}
      color="purple.10"
      iconName="ChevronRight"
      isTooltipDisabled
      onClick={onNext}
      size="sm"
      variant="tertiary"
      visibility={controls === 'left' ? 'hidden' : undefined}
    />
  );
};

const DatePickerHeader = ({
  children,
  controls = 'both',
  onNext,
  onPrevious,
}: {
  onPrevious: () => void;
  onNext: () => void;
  controls?: 'left' | 'right' | 'both';
  children?: ReactNode;
}): JSX.Element => {
  const ctx = useObjectMemo({ controls, onNext, onPrevious });
  return (
    <Box
      alignItems="center"
      display="grid"
      gap="4"
      gridTemplateColumns="2rem auto 2rem"
      marginBottom="24"
      width="17.5rem"
    >
      <HeaderContext value={ctx}>{children}</HeaderContext>
    </Box>
  );
};
export default DatePickerHeader;
